import React, { useState, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import Strings from  '../common/Strings';
import { StateArray } from '../common/Constants';
import { patternMessage, invalidInputStyle, selectOptions, checkboxMessage } from '../common/Forms';

import { getAccountsApiUrl, apiGet, apiPost } from '../common/AppApi';
import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';
import MessageTag2 from '../common/MessageTag';
import { decodeValues, formatPhone } from '../common/Formats'

export default function CTApplication() {
    let blankApplicant = {
        firstname:'',
        lastname:'',
        middlename:'',
        address1:'',
        address2:'',
        city:'',
        stateId:'',
        zipcode:'',
        email:'',
        mobilePhone:''
    };
    
    let [applicant, setApplicant] = useState(blankApplicant);
    let [screen, setScreen] = useState(-1);
    let [applicantion, setApplication] = useState({name:'',descr:''});
    let [program, setProgram] = useState({programId:null, programUuid:'', programName:'', shortName:''});

    let [showSpinner, setSpinner] = useState(false);
    let [message, setMessage] = useState();
    let [message2, setMessage2] = useState();
    let [agreementHtml, setAgreementHtml] = useState('');

	let handleFieldChange = (event) => {
		const {id, value} = event.target;
		let cloned = {...applicant, [id]:value};
		setApplicant(cloned);
	}

    let stopSpinner = () => {
        setSpinner(false);
    };

    let handleNextScreen = (e) => {
        e.preventDefault();
        setScreen(screen + 1);
    };
    let previousScreen = () => {
        setScreen(screen - 1);
    };

    let getApplInfo = () => {
        let success = (resp) => {
            //console.debug(resp);

            if (resp) {
                setApplication(resp);
                if (resp && resp.active == true && resp.programs && resp.programs.length) {
                    setProgram(resp.programs[0])
                    setScreen(1);
                } else {
                    setMessage({text:Strings.warning.onlineAppUnavailable, type:'warning'});
                }
            } else {
                setMessage({text:Strings.warning.onlineAppUnavailable, type:'warning'});
            }

        };
        let fail = (resp) => {
            console.error(resp);
            setMessage({text:Strings.warning.onlineAppUnavailable, type:'warning'});
        };

        setSpinner(true);

        apiGet(getAccountsApiUrl() + '/application/1')
        .then(success)
        .catch(fail)
        .finally(stopSpinner);
    }

    let handleSubmit = (e) => {
        e.preventDefault();
        console.debug('submit to backend');

        setSpinner(true);

        let body = {...applicant, programId:program.programId};

        apiPost(getAccountsApiUrl() + '/applicant', body).then( (resp) => {
            //console.debug(resp);
            setScreen(screen + 1);
        }).catch( (error) => {
            console.debug(error);
            setMessage2({text:"The application cannot be submitted at this time.", type:'danger'});
        })
        .finally(stopSpinner);
    };

    useEffect( () => {

        getApplInfo();

        fetch('/terms-of-use.html')
        .then( (resp) => resp.text() )
        .then(setAgreementHtml)
        .catch( (error) => console.error(error) );
    }, []);

    let doAgreementMarkup = () => {
        return {__html: agreementHtml};
    };

    let btnMargin = {marginRight:'.2em'};

    let doMarkup = () => {
        return {__html: applicantion.descr};
    };

    if (screen == 1) {
		patternMessage("#zipcode", Strings.validation.zipFormat);
		patternMessage("#mobilePhone", Strings.validation.phoneFormat);
		patternMessage("#email", Strings.validation.emailFormat);

        return (
            <div className="container">
                <h3>{applicantion.name}</h3>
                <p dangerouslySetInnerHTML={doMarkup()}></p>

                <form onSubmit={handleNextScreen}>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-5">
                            <label className="asterisk-label" htmlFor="firstname">First Name</label>
                            <input type="text" id="firstname" className="form-control" onChange={handleFieldChange} value={applicant.firstname} required maxLength="100" />
                        </div>
                        <div className="form-group col-12 col-sm-2">
                            <label htmlFor="middlename">Middle Initial</label>
                            <input type="text" id="middlename" className="form-control" onChange={handleFieldChange} value={applicant.middlename} maxLength="1" />
                        </div>
                        <div className="form-group required col-12 col-sm-5">
                            <label className="asterisk-label" htmlFor="lastname">Last Name</label>
                            <input type="text" id="lastname" className="form-control" onChange={handleFieldChange} value={applicant.lastname} required maxLength="100" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="address1">Address Line One</label>
                            <input type="text" id="address1" className="form-control" onChange={handleFieldChange} value={applicant.address1} required maxLength="60" />
                        </div>
                        <div className="form-group col-12 col-sm-6">
                            <label htmlFor="address2">Address Line Two</label>
                            <input type="text" id="address2" className="form-control" onChange={handleFieldChange} value={applicant.address2} maxLength="60"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="addr1">City</label>
                            <input type="text" id="city" className="form-control" onChange={handleFieldChange} value={applicant.city} required maxLength="60" />
                        </div>
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="stateId">State</label>
                            <select id="stateId" className="form-control custom-select" value={applicant.stateId} onChange={handleFieldChange} required >
                                { selectOptions(StateArray, 'id2') }
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="zipcode">Zip Code</label>
                            <input type="text" id="zipcode" className="form-control" onChange={handleFieldChange} value={applicant.zipcode} required maxLength="10" pattern="(\d{5}([\-]\d{4})?)" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="email">Email</label>
                            <input type="email" id="email" className="form-control" onChange={handleFieldChange} value={applicant.email} required maxLength="255" pattern={Strings.pattern.email}/>
                        </div>
                        <div className="form-group required col-12 col-sm-6">
                            <label className="asterisk-label" htmlFor="mobilePhone">Mobile Phone</label>
                            <input type="text" id="mobilePhone" className="form-control" onChange={handleFieldChange} value={applicant.mobilePhone} required maxLength="20" pattern={Strings.pattern.phone} />
                        </div>
                    </div>
                    <button className="btn btn-primary" id="btnReview" disabled={program.programId==null}>Review Application</button>
                </form>
            </div>
        );
    } else if (screen == 2) {
        return <div className='container'>
                <h3>{applicantion.name}</h3>
                <h4>Applicant Information</h4>
                <p>Please review the information that you have provided before continuing with the application.</p>
                <table className='table table-bordered'>
                <tbody>
                    <tr>
                        <th>First Name</th>
                        <td>{applicant.firstname}</td>
                        <th>Middle Name</th>
                        <td>{applicant.middlename}</td>
                        <th>Last Name</th>
                        <td>{applicant.lastname}</td>
                    </tr>
                    <tr>
                        <th>Address Line One</th>
                        <td colSpan={5}>{applicant.address1}</td>
                    </tr>
                    <tr>
                        <th>Address Line Two</th>
                        <td colSpan={5}>{applicant.address2}</td>
                    </tr>
                    <tr>
                        <th>City</th>
                        <td>{applicant.city}</td>
                        <th>State</th>
                        <td>{decodeValues(applicant.stateId, StateArray, 'id2')}</td>
                        <th>Zip Code</th>
                        <td>{applicant.zipcode}</td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td colSpan={2}>{applicant.email}</td>
                        <th>Mobile Phone</th>
                        <td>{formatPhone(applicant.mobilePhone)}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <button className="btn btn-primary" type='button' style={btnMargin} onClick={previousScreen} id="btnEdit">Edit Application</button>
            <button className="btn btn-primary" type='button' style={btnMargin} onClick={handleNextScreen} id="btnContinue">Continue With Application</button>
        </div>
    } else if (screen == 3) {
        let checkboxMessage = (e) => {
            let myMsg = '';
            if (e.target.validity.valueMissing)
                myMsg = 'You must agree to the above statements to submit the application.';
            e.target.setCustomValidity(myMsg);
        };
        let checkBoxStyle = {accentColor: '#56CC9D', transform:'scale(1.4)'};
        return <div className='container'>
            <h3>{applicantion.name}</h3>
            <br/>
            <Processing show={showSpinner}/>
            <div dangerouslySetInnerHTML={doAgreementMarkup()}></div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group col-12">
                        <div className="form-check">
                            <label className='form-check-label' htmlFor="iAgree" style={{padding:'.1em'}}>
                            <input className="form-check-input" type="checkbox" value="true" id="iAgree" style={checkBoxStyle} required onInvalid={checkboxMessage} onChange={checkboxMessage} />
                            &nbsp;I understand and agree to the <strong>Terms of Use</strong> defined above.
                            </label>
                        </div>
                    </div>
                <button className='btn btn-success' id='btnSubmit'>Submit Application</button>
                <span style={{display:'inline-block', margin:'.7em'}}>
                <MessageTag2 message={message2}/>
                </span>
                <br/>

                <button className="btn btn-primary" type='button' onClick={previousScreen} id="btnBack">Back To Review Application</button>
            </form>
        </div>
    } else if (screen == 4) {
        return <div className='container'>
            <h3>{applicantion.name}</h3>
            <h4 id="thankYou">Thank You</h4>
            <p>The application has been received.</p>
            <a href="">Add Another Application</a>
        </div>
    } else {
        return <div className='container'>
            <h3>{applicantion.name}</h3>
            <MessageTag message={message}/>
            <Processing show={showSpinner}/>
            <p>Sorry for the inconvenience.</p>
        </div>
    }
}
